<template>
  <div class="home">
     <v-calendar
     locale="uk"
     ></v-calendar>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  }
}
</script>
